import React from "react";
import PropTypes from 'prop-types';
import { colors } from '../../../config/ui';

export default class MainTitle extends React.PureComponent {
    render() {
        let { text, color } = this.props;

        return (
            <div className={'main-title' + (color ? (' ' + color) : '')}>
                {text}
            </div>
        );
    }
}

MainTitle.propTypes = {
    text: PropTypes.string.isRequired,
    color: PropTypes.oneOf(colors)
};
